import { render, staticRenderFns } from "./visualize-accredited.vue?vue&type=template&id=28ac042c&scoped=true&"
import script from "./visualize-accredited.vue?vue&type=script&lang=js&"
export * from "./visualize-accredited.vue?vue&type=script&lang=js&"
import style0 from "./visualize-accredited.vue?vue&type=style&index=0&id=28ac042c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ac042c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CFlex: require('@chakra-ui/vue').CFlex})
